// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-outcome {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.35rem;
  width: 100%;
}

.cm-outcome__btn {
  --oc: #94a3b8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.12rem;
  min-width: 0;
  min-height: 2.7rem;
  padding: 0.28rem 0.2rem 0.32rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--oc) 45%, transparent);
  background: color-mix(in srgb, var(--oc) 12%, transparent);
  color: inherit;
  cursor: pointer;
  font: inherit;
}

.cm-outcome__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-outcome__btn.is-on {
  background: color-mix(in srgb, var(--oc) 28%, transparent);
  box-shadow: inset 0 0 0 1.5px var(--oc);
}

.cm-outcome__mark {
  font-size: 0.95rem;
  line-height: 1;
}

.cm-outcome__text {
  max-width: 100%;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: -0.01em;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-outcome__btn--winner {
  --oc: #22c55e;
}

.cm-outcome__btn--unforced_error {
  --oc: #ef4444;
}

.cm-outcome__btn--forced_error {
  --oc: #eab308;
}

.cm-outcome__btn--lucky {
  --oc: #94a3b8;
}

.cm-outcome__btn--rally {
  --oc: #0ea5e9;
}
`, "",{"version":3,"sources":["webpack://./src/components/PointOutcomeBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,gEAAgE;EAChE,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".cm-outcome {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.35rem;\n  width: 100%;\n}\n\n.cm-outcome__btn {\n  --oc: #94a3b8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.12rem;\n  min-width: 0;\n  min-height: 2.7rem;\n  padding: 0.28rem 0.2rem 0.32rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--oc) 45%, transparent);\n  background: color-mix(in srgb, var(--oc) 12%, transparent);\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n}\n\n.cm-outcome__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-outcome__btn.is-on {\n  background: color-mix(in srgb, var(--oc) 28%, transparent);\n  box-shadow: inset 0 0 0 1.5px var(--oc);\n}\n\n.cm-outcome__mark {\n  font-size: 0.95rem;\n  line-height: 1;\n}\n\n.cm-outcome__text {\n  max-width: 100%;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: -0.01em;\n  line-height: 1.1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-outcome__btn--winner {\n  --oc: #22c55e;\n}\n\n.cm-outcome__btn--unforced_error {\n  --oc: #ef4444;\n}\n\n.cm-outcome__btn--forced_error {\n  --oc: #eab308;\n}\n\n.cm-outcome__btn--lucky {\n  --oc: #94a3b8;\n}\n\n.cm-outcome__btn--rally {\n  --oc: #0ea5e9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
